module.exports = __webpack_public_path__ + "static/img/hidden.39738cc3.png";